'use strict'
var abortCb = require('../util/abort-cb')

module.exports = function once (value, onAbort) {
  return function (abort, cb) {
    if(abort)
      return abortCb(cb, abort, onAbort)
    if(value != null) {
      var _value = value; value = null
      cb(null, _value)
    } else
      cb(true)
  }
}





//////////////////
// WEBPACK FOOTER
// ./node_modules/pull-stream/sources/once.js
// module id = 328
// module chunks = 0